import { render, staticRenderFns } from "./downloadList.vue?vue&type=template&id=418429b2&scoped=true"
import script from "./downloadList?vue&type=script&lang=js&external"
export * from "./downloadList?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418429b2",
  null
  
)

export default component.exports